// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3f58335e","703":"0483ebdd","741":"a79f6ae6","846":"31374e9a"}[chunkId] + ".chunk.js";
};